const API_KEY = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiZWZjNjM1ZmZiY2M3NWFkODEyNGQwNjFkYTQxY2ExOTliMjk5MmFmNmI4ODdjM2U1YjhhZDQyMDc5YjE1YzJmMzMwMTI3NWVjOGQ2MWU4YTMiLCJpYXQiOjE3NDEyNzIxNjYsIm5iZiI6MTc0MTI3MjE2NiwiZXhwIjozNjM0NzI4MTY2LCJzdWIiOiIxMjM5NiIsInNjb3BlcyI6W119.rFHmGMwDIm_X61JdejBMMgeU8FisfKdAq0iq1snk-mszKXIPyTzylFFWnsla0h4E22OH-_40XJZNJ9gyTVhR_nJ27-uSBtVevJTwlF32zJIcSPg21E0PLMSKOaneqi0hjlmNfypyjldSMxBQybUZvIYWQbVIkmk7hsA1MN99Jr9o3wsANM6gnN_N9nYFfCjJhwrWQPOnbXCqKa0BBkgMlQ6UjyczyRV6LfSgLR8nvhjbjjHvWpRMcTJIjcCt1govYytrf7LlJZw1xH4x8ngg2AyAG8xnE_8_MjPwlZCEXylfhQoUhRSSW2lJkBDySOd2SGn8udWFqdrQF6Ljtenz_A2qo0Ij5bIxPtjUYxYSZzhh8dQE4AEgHgHHx_2VgS5NO2v4BeQkCObMWG6duLvmNeDpHpGE5P7wxgII1ViafZeo5veaf8wMhOzp5u-A_xiVJC-Tcja3xzlUVxj2rE2sGEJ_9T4b0S7Rzu7yW9qoDk9qU3fLwTFDyzCpq0TPDsROuMhADJgRWxAqTrySNAkSrXhjSMOtrAFS8HwZfU5xWiUyVThkgtwU9lclF2SdUnKnwCz2gSq6ePOUjSjD9SGsaNcLlEzljfxgR0hPKb8uiXGCd6xLSTgwIkGLGTj8bn09nDoE3O1DlvwrC_3qx4Uy0SniFSMPZ55AdBiYn-zwUHc"

const DOMAIN_NAME = "aston-and-fincher.myshopify.com";
const REQUIRED_WISHLISTS = ['Stock List'];

let _wishListsInitPromise = null;

const initWishLists = (customerId) => {
    if (!_wishListsInitPromise) {
        _wishListsInitPromise = (async () => {
            const wishlists = await getWishLists(customerId);
            const newWishListsRes = await Promise.all(addMissingWishLists(customerId, wishlists));
            window.customWishLists = extractDesiredWishLists([...wishlists, ...newWishListsRes]);
        })().catch((err) => {
            _wishListsInitPromise = null;
            throw err;
        });
    }
    return _wishListsInitPromise;
};

window.refreshWishLists = async (buttonGroup, productId, variantId, customerId) => {
    if (customerId === null) {
        console.log('Missing Customer ID');
        return;
    }
    await initWishLists(customerId);
    updateButtons(buttonGroup, productId, variantId);
}

const updateButtons = (buttonGroup, productId, variantId) => {
    const buttons = buttonGroup.querySelectorAll('button')

    buttons.forEach(button => {
        const list = button.dataset.list;
        const wishlist = window.customWishLists[list];

        const productInWishList = wishlist.products.find(
            p => p.pivot.shopify_product_id == productId && p.pivot.shopify_variant_id == variantId
        );

        button.innerHTML = window.toggleText(button.innerHTML, productInWishList)

        button.classList.add('visible')
    })
}

window.toggleText = (initial, productInWishList) => {
    if (productInWishList) {
        return initial.replace('Add to', 'Remove from').replace('<svg', '<svg class="saved"')
    }
    return initial.replace('Remove from', 'Add to').replace('<svg class="saved"', '<svg')
}

/**
 * Adds a product variant to the stock list.
 *
 * @param {Event} e - The event object from the button click.
 * @param {string} productId - The ID of the product.
 * @param {string} variantId - The ID of the variant.
 * @param {string} customerId - The ID of the customer
 */
window.toggleToList = (e, productId, productHandle, variantId, customerId) => {
    e.preventDefault();
    if (!variantId) {
        // Navigate to the product page with a flag for the toast notification
        sessionStorage.setItem('stockListRedirect', 'true');
        window.location.href = `/products/${productHandle}`;
        return
    }

    const target = e.target.closest('[data-list]');

    const list = target.dataset.list;
    const wishlist = window.customWishLists[list];

    if (!wishlist) {
        console.error('WishList not found')
        return;
    }

    const productInWishList = wishlist.products.find(
        p => p.pivot.shopify_product_id == productId && p.pivot.shopify_variant_id == variantId
    );

    const data = {
        product_id: productId,
        variant_id: variantId,
        customer_id: customerId,
        wishlist_ids: [wishlist.id],
        type: "API"
    };


    const encryptToken = btoa(CryptoJS.SHA256(DOMAIN_NAME + customerId).toString());
    fetch(`https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist/${productInWishList ? 'delete_product' : 'add_product'}`, {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${API_KEY}`,
            "Encrypt-token": encryptToken,
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(async res => {
            target.innerHTML = window.toggleText(target.innerHTML, !productInWishList)
            if (productInWishList) {
                wishlist.products = wishlist.products.filter(
                    p => p.pivot.shopify_product_id != productId || p.pivot.shopify_variant_id != variantId
                );
            } else {
                wishlist.products.push({
                    // Bit jank but it works ¯\_(ツ)_/¯
                    pivot: {
                        shopify_product_id: productId,
                        shopify_variant_id: variantId
                    }
                })
            }

            return res
        })
}

const checkInWishList = async (customerId, list, productId, variantId) => {
    const wishlistId = window.customWishLists[list];

    if (!wishlistId) {
        console.error('WishList not found')
        return;
    }

    const data = {
        product_id: productId,
        variant_id: variantId,
        customer_id: customerId,
        wishlist_ids: [wishlistId],
        type: "API"
    };

    const encryptToken = btoa(CryptoJS.SHA256(DOMAIN_NAME + customerId).toString());
    fetch("https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist/add_product", {
        method: "POST",
        headers: {
            "Authorization": `Bearer ${API_KEY}`,
            "Encrypt-token": encryptToken,
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
}

const getWishLists = async (customerId) => {
    const encryptToken = btoa(CryptoJS.SHA256(DOMAIN_NAME + customerId).toString());
    return fetch(`https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist/lists?customer_id=${customerId}`, {
        method: "GET",
        headers: {
            "Authorization": `Bearer ${API_KEY}`,
            "Encrypt-token": encryptToken,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    })
    .then(response => response.json())
    .catch((error) => {
        console.error("Error:", error);
    });
}


const addMissingWishLists = (customerId, wishlists) => {
    const missingWishLists = REQUIRED_WISHLISTS.filter(
        wishlist => !wishlists.some(w => w.name === wishlist)
    );

    const encryptToken = btoa(CryptoJS.SHA256(DOMAIN_NAME + customerId).toString());

    return missingWishLists.map(async missingWishList => {
        const data = {
            customer_id: customerId,
            name: missingWishList
        };

        return fetch("https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist/create", {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${API_KEY}`,
                "Encrypt-token": encryptToken,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .catch((error) => {
            console.error("WishList Error:", error);
        });
    })
}

const extractDesiredWishLists = (wishlists) => {
    const res = {}
    for (const wishlist of wishlists) {
        if (REQUIRED_WISHLISTS.includes(wishlist.name)) {
            res[wishlist.name] = wishlist
            continue
        }

        if (wishlist.is_default) {
            res['__default'] = wishlist
        }
    }

    return res
}

// Initialize stocklist script
let doublePrevent = null;

function processContainer(buttonGroup) {
    // If it's the correct product
    window.refreshWishLists(
        buttonGroup,
        buttonGroup.getAttribute('data-product-id'),
        buttonGroup.getAttribute('data-variant-id'),
        buttonGroup.getAttribute('data-customer-id'),
    );
}

function initStockListFavourites() {
    if (doublePrevent) return;
    doublePrevent = window.setTimeout(() => {
        doublePrevent = null;
    }, 200);

    // Process existing containers
    const containers = document.getElementsByClassName('stock-list-favourites-container')
    for (let i = 0; i < containers.length; i++) {
        processContainer(containers.item(i));
    }
}

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type !== 'childList') return
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return

            if (node.classList && node.classList.contains('stock-list-favourites-container')) {
                processContainer(node);
            }

            // Check if the node contains any containers
            const containers = node.getElementsByClassName('stock-list-favourites-container');
            for (let i = 0; i < containers.length; i++) {
                processContainer(containers.item(i));
            }
        });
    });
});

observer.observe(document.body, { childList: true, subtree: true });

initStockListFavourites();
